export function setActiveAudio(data) {
  return {
    type: 'SET_ACTIVE_AUDIO',
    payload: data,
  }
}
